import React from 'react';

import './Footer.css';

const Footer = () => {
    return (
        <div>
            <hr/>
            <div className="copyright">© 2020 Squawk Studio, LLC</div>
        </div>
    );
};

export default Footer;